<template>
  <v-container
    fluid
    style="padding-top: 72px; padding-bottom: 48px; height: 100%"
    grid-list-xl
  >
    <v-layout row justify-center fill-height>
      <v-flex xs10>
        <v-layout column class="text-xs-center">
          <v-flex shrink style="padding-bottom: 45px">
            <v-layout row align-center justify-center>
              <v-flex shrink>
                <span>
                  <img
                    height="100"
                    src="../../public/img/vde-service-logo.png"
                  />
                </span>
              </v-flex>
              <v-flex shrink>
                <span
                  style="
                    padding-left: 15px;
                    font-weight: bold;
                    font-size: 1.4rem;
                  "
                >
                  VdE-Service GmbH
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            shrink
            style="padding-bottom: 45px; font-size: 1.8rem; font-weight: bold"
          >
            Herzlich willkommen beim Datenschutz-Schulungstool der VdE-Service
            GmbH
          </v-flex>
          <v-flex shrink style="padding-bottom: 21px; font-size: 1.4rem">
            Hier können Sie online Ihre Datenschutzschulung(en) absolvieren, die
            Sie bei der Erfüllung der Anforderungen des Datenschutzes in Ihrem
            Berufsleben unterstützt.
          </v-flex>
          <v-flex shrink style="padding-bottom: 21px; font-size: 1.4rem">
            Bitte loggen Sie sich mit Ihrer E-Mail-Adresse und dem Kennwort, das
            wir Ihnen im Vorfeld geschickt haben ein. Sollten Sie das Kennwort
            vergessen oder verlegt haben, geben Sie bitte Ihre E-Mail-Adresse
            ein und wählen Sie dann "Passwort vergessen".
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-btn @click="moveToLogin()"> Zum Login </v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex>
            Diese Website verwendet ausschließlich technisch notwendige Cookies.
            Weitere Informationen zu Cookies finden Sie in unserer
            <a
              href="https://wdt.vde-service.de/wdt/datenschutzerklaerung.pdf"
              target="_blank"
              >Datenschutzerklärung.</a
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Welcome',

  methods: {
    moveToLogin() {
      window.location.href = location.protocol + '//' + location.host + '/wst/#/login';
    }
  }
};
</script>

<style>
</style>